var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 12.0001C14.0667 12.0001 14.66 11.4001 14.66 10.6667L14.6667 4.00008C14.6667 3.26675 14.0667 2.66675 13.3333 2.66675H2.66667C1.93333 2.66675 1.33333 3.26675 1.33333 4.00008V10.6667C1.33333 11.4001 1.93333 12.0001 2.66667 12.0001H0V13.3334H16V12.0001H13.3333ZM2.66667 4.00008H13.3333V10.6667H2.66667V4.00008Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.33896f5930a412b972089b74ee67242f.svg";
export { ForwardRef as ReactComponent };